module.exports = __webpack_public_path__ + "img/bo.64a0f086.svg";